import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  filtersContainer: {
    display: 'flex',
    flexFlow: 'column wrap',
    alignItems: 'flex-start',
    gap: 16,
    borderBottom: `1px solid ${theme.rawColors.lightGrey500}`,
    padding: ['24px 24px 12px 40px', '24px 24px 12px 40px', '24px 24px 12px 40px', '24px 24px 12px 40px', '24px 40px 12px 40px']
  },
  button: {
    paddingBottom: '0',
    '& span:last-child': {
      fontSize: theme.fontSizes.text,
      height: 'auto',
      margin: 'auto 0 0 16px'
    }
  },
  firstLine: {
    width: '100%',
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'flex-start',
    justifyContent: 'space-between'
  },
  filtersList: {
    display: 'flex',
    width: 'auto',
    flexFlow: 'row wrap',
    alignItems: 'flex-start',
    justifyContent: 'flex-start'
  },
  filterAsideContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  filterHeaderContainer: {
    position: 'relative',
    mb: '16px'
  },
  filterHeader: {
    textAlign: 'center'
  },
  backButton: {
    background: 'none',
    border: 'none',
    zIndex: theme.zIndex.documentUp,
    display: 'inline-block',
    top: ['20px', '40px', '40px', '40px', '40px', '40px'],
    left: ['24px', '38px', '38px', '38px', '38px', '38px'],
    position: 'absolute'
  },
  filler: {
    flex: 1
  },
  filterLinkList: isHidden => ({
    listStyleType: 'none',
    display: isHidden ? 'block' : 'none',
    li: {
      display: 'inline-flex',
      lineHeight: '19px',
      width: '100%',
      flexDirection: 'row',
      my: '14px',
      letterSpacing: '.05rem',
      justifyContent: 'space-between'
    }
  }),
  filterLinkButton: {
    '.button-children-wrapper': {
      width: '100%',
      fontWeight: 100,
      justifyContent: 'space-between'
    }
  },
  headerContainer: {
    flexShrink: 0,
    padding: ['16px', '38px 40px'],
    '.headings::first-letter': {
      textTransform: 'uppercase'
    }
  },
  filterContent: {
    overflow: 'auto',
    p: '0 30px 30px 30px',
    ...reusables.scrollbar()
  },
  filterButtons: {
    padding: ['16px', '38px 40px']
  }
};